import FetchRequest from '../enums/fetchRequest';
import { searchParametersSlice } from '../redux/slices';

const actions = searchParametersSlice.actions;

// The listings call gets the HTML string about all the cards that is shown on the page.
// The Counts call gets the counting value related to the search.
// The SchoolsAndBrandsFaceting call gets the custom faceting values related to schools and brands
// that depends on the search.
const allResultsCalls = [FetchRequest.Listings, FetchRequest.Counts, FetchRequest.SchoolsAndBrandsFaceting];

// Here we have the list about the result calls that we have to do according to the action that was
// triggered. Where currently we have the listings, counts and Facets calls.
const fetchRequestListByAction = {
  [actions.fetchBuilderReviews.type]: allResultsCalls,

  [actions.fetchConsumerPromos.type]: allResultsCalls,

  [actions.fetchActiveAdult.type]: allResultsCalls,

  [actions.fetchExcludeActiveAdult.type]: allResultsCalls,

  [actions.fetchAnyCommunities.type]: allResultsCalls,

  [actions.fetchPageSize.type]: [FetchRequest.Listings],

  [actions.fetchPageNumber.type]: [FetchRequest.Listings],

  [actions.fetchPagingControlsNext.type]: [FetchRequest.Listings],

  [actions.fetchPagingControlsPrev.type]: [FetchRequest.Listings],

  [actions.fetchBathrooms.type]: allResultsCalls,

  [actions.fetchBedrooms.type]: allResultsCalls,

  [actions.fetchLocations.type]: allResultsCalls,

  [actions.fetchPrice.type]: allResultsCalls,

  [actions.fetchResultsType.type]: allResultsCalls,

  [actions.fetchSort.type]: [FetchRequest.Listings],

  [actions.fetchLivingAreas.type]: allResultsCalls,

  [actions.fetchStories.type]: allResultsCalls,

  [actions.fetchPrimaryBedroom.type]: allResultsCalls,

  [actions.fetchGarages.type]: allResultsCalls,

  [actions.fetchAmenities.type]: allResultsCalls,

  [actions.fetchMoveInDateByStatus.type]: allResultsCalls,

  [actions.clearMoveInDateFilter.type]: allResultsCalls,

  [actions.clearFilters.type]: allResultsCalls,

  [actions.fetchMoveInDateByRange.type]: allResultsCalls,

  [actions.fetchCustom.type]: allResultsCalls,

  [actions.fetchSingleFamily.type]: allResultsCalls,

  [actions.fetchLuxury.type]: allResultsCalls,

  [actions.fetchCondosAndTownHomes.type]: allResultsCalls,

  [actions.fetchManufactured.type]: allResultsCalls,

  [actions.fetchBrandId.type]: allResultsCalls,

  [actions.fetchViewBrandResults.type]: allResultsCalls,

  [actions.fetchViewBrandMarketResults.type]: allResultsCalls,

  [actions.fetchRvGarages.type]: allResultsCalls,

  [actions.fetchGolfCourse.type]: allResultsCalls,

  [actions.fetchMarketingStatus.type]: allResultsCalls,

  [actions.fetchPriceReduction.type]: allResultsCalls,

  [actions.fetchModelHome.type]: allResultsCalls,

  [actions.allOptions.type]: allResultsCalls,

  [actions.fetchHomeOwnersAssociationFee.type]: allResultsCalls,

  [actions.fetchInteractiveSitePlanResults.type]: allResultsCalls,
};

/**
 * validateIfFetchRequest: Checks if the fetch request should be triggered according the action.
 * @param {string} actionType Name of the action.
 * @param {FetchRequest} fetchRequest Request to validate if it should ve fetched
 * @returns A boolean value indicating if the fetch request should be triggered according to action.
 */
const validateIfFetchRequest = (actionType, fetchRequest) => {
  const fetchRequestList = fetchRequestListByAction[actionType];
  if (!fetchRequestList) {
    return false;
  }

  return fetchRequestList.includes(fetchRequest);
};

export default validateIfFetchRequest;
